import './../../index.css';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import hoc from '../../hoc.js';
import 'classnames';
import '@hh.ru/magritte-common-use-disabled';
import '@hh.ru/magritte-ui-badge';
import '../../IconDynamic-BiKz7_SZ.js';
import '../../Skeleton.js';
import '@hh.ru/magritte-ui-skeleton';

const PhoneFilledSize24Component = (props, ref) => (jsx("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("g", { children: jsx("g", { children: jsx("path", { d: "M9.58005 5.61919L5.66967 0C-3.53412 2.59796 -0.234636 11.0266 6.38176 17.6404C12.9982 24.2542 21.3952 27.5174 24 18.3231L18.3786 14.4143L15.368 15.732C14.8573 15.9555 14.2782 15.962 13.8007 15.6745C13.1266 15.2686 12.0565 14.5177 10.7811 13.2428C9.49955 11.9619 8.74737 10.8881 8.34273 10.2149C8.05904 9.7429 8.06291 9.17141 8.27919 8.66502L9.58005 5.61919Z", fill: "var(--magritte-ui-icon-color)" }) }) }) }));
const PhoneFilledSize24 = hoc(forwardRef(PhoneFilledSize24Component), 'PhoneFilledSize24');

export { PhoneFilledSize24 as default };
//# sourceMappingURL=PhoneFilledSize24.js.map
